
import cartTrashIcon from '~/assets/img/trash-cart__icon.svg'
export default {
  name: 'ButtonDelete',
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cartTrashIcon,
    }
  },
  methods: {
    clickHandler() {
      this.$emit('onRemoveProductFromCart')
    },
  },
}
